/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useSearchParams } from "react-router";
import { useAuth } from '@/commons/auth';
import FormTambahJadwalKelas from '../components/FormTambahJadwalKelas'

import getRuangan from '../services/getRuangan'
import getHari from '../services/getHari'
const TambahJadwalKelasPage = props => {
const { id, kelasId } = useParams()
	const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	tambahJadwalKelas: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [ruangan, setRuangan] = useState()
const [hari, setHari] = useState()

useEffect(() => {
    const fetch = async () => {
	  setIsLoading(prev => ({...prev, tambahJadwalKelas: true}))
		const { data: ruanganResponse } = await getRuangan({   })
		const { data: hariResponse } = await getHari({   })

	    setRuangan(ruanganResponse.data)
	    setHari(hariResponse.data)


	    setIsLoading(prev => ({...prev, tambahJadwalKelas: false}))
    }
	if (checkPermission("SaveJadwalKelas")) { 
		fetch()
	}
  }, [])

	
	useEffect(() => {
		setTitle("Tambah Jadwal Kelas Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/kelas/${kelasId}
			  	`}>
			  		<Button id="_K1k9YCwGEfCz9KF7E6i0TQ" className="p-4" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			</>
		}
	>
{ checkPermission("SaveJadwalKelas") && ( 
	<Layouts.FormContainerLayout
		singularName={"Jadwal"}
		isLoading={isLoading.tambahJadwalKelas}
	>
		{ruangan && hari ? 
		(<>
		 <FormTambahJadwalKelas
			{...{ 
				ruangan
, 				hari
				}}
		 /> 
		</>)  : (<></>)}
	</Layouts.FormContainerLayout>

)}

	</Layouts.ViewContainerLayout>
  )
}
export default TambahJadwalKelasPage

